module.exports = __webpack_public_path__ + "img/tela-login.f7c100cc.svg";